// About the Founder — Ajay Pachpute
// Full trilingual content is out of scope for v1 (matching the pattern used for
// /constitution, /roadmap, /national). English long-form text is authoritative;
// section labels are provided in EN / HI / MR for the trilingual UI shell.

export function pickLang(obj, lang) {
  if (!obj) return obj;
  if (obj[lang] !== undefined) return obj[lang];
  return obj.en;
}

// ---------------------------------------------------------------------------
// Section labels (trilingual)
// ---------------------------------------------------------------------------
export const FOUNDER_LABELS = {
  en: {
    nav: 'Founder',
    kicker: 'The Founder',
    hero_role: 'Founder — National Governance Reform Party',
    credentials_label: 'Credentials',
    tag_civil_eng: 'Civil Engineer',
    tag_entrepreneur: 'Entrepreneur',
    tag_infra: 'Infrastructure & Renewable Energy Professional',
    about_kicker: 'About the founder',
    about_title: 'A citizen who chose reform over rhetoric',
    conviction_label: 'Central conviction',
    why_kicker: 'Why NGRP was founded',
    why_title: 'A new pipeline for public leadership',
    pipeline_label: 'The leadership pipeline',
    who_label: 'Who NGRP is for',
    who_body: 'Young people. UPSC / MPSC and other civil-service aspirants. Engineers, doctors, lawyers, teachers, farmers, entrepreneurs, professionals, social workers and experienced grassroots leaders.',
    independence_label: 'Independence from the founder',
    independence_body: 'The objective is not to make NGRP dependent on its founder. Instead, NGRP is intended to develop transparent internal institutions capable of producing future leaders — from Gram Panchayat and municipal levels to State Legislatures and Parliament.',
    philosophy_kicker: 'Founder’s governance philosophy',
    philosophy_title: 'From person-dependent government to system-driven governance',
    philosophy_after: 'Ajay advocates a transition from person-dependent governance to system-driven governance — with time-bound citizen services, transparent public expenditure, reduced administrative friction, digital accountability, measurable government performance and stronger institutional safeguards against corruption.',
    mission_kicker: 'A national mission',
    mission_title: 'One nation. Many languages. Shared constitutional principles.',
    mission_body: 'NGRP is envisioned for all regions of India, respecting India’s diversity of languages, cultures and local priorities while maintaining common constitutional and governance principles.',
    org_philosophy_label: 'Organisational philosophy',
    objective_kicker: 'Long-term objective',
    objective_title: 'Constitution above personalities. Institutions above individuals.',
    signature_label: 'Signed',
    read_more_about: 'Read more about NGRP',
    read_vision: 'Read the Founding Vision',
    read_pan_india: 'Read the Pan-India movement',
    read_constitution: 'Read the Constitution',
  },
  hi: {
    nav: 'संस्थापक',
    kicker: 'संस्थापक',
    hero_role: 'संस्थापक — नेशनल गवर्नेंस रिफॉर्म पार्टी',
    credentials_label: 'योग्यताएँ',
    tag_civil_eng: 'सिविल इंजीनियर',
    tag_entrepreneur: 'उद्यमी',
    tag_infra: 'बुनियादी ढाँचा एवं नवीकरणीय ऊर्जा पेशेवर',
    about_kicker: 'संस्थापक के बारे में',
    about_title: 'एक नागरिक जिसने बयानबाज़ी की जगह सुधार को चुना',
    conviction_label: 'मूल विश्वास',
    why_kicker: 'एनजीआरपी की स्थापना क्यों',
    why_title: 'सार्वजनिक नेतृत्व के लिए एक नई पाइपलाइन',
    pipeline_label: 'नेतृत्व पाइपलाइन',
    who_label: 'एनजीआरपी किनके लिए है',
    who_body: 'युवा। यूपीएससी / एमपीएससी और अन्य सिविल-सेवा उम्मीदवार। इंजीनियर, डॉक्टर, वकील, शिक्षक, किसान, उद्यमी, पेशेवर, सामाजिक कार्यकर्ता और अनुभवी ज़मीनी नेता।',
    independence_label: 'संस्थापक से स्वतंत्रता',
    independence_body: 'उद्देश्य एनजीआरपी को इसके संस्थापक पर निर्भर बनाना नहीं है। इसके बजाय, एनजीआरपी ऐसी पारदर्शी आंतरिक संस्थाएँ विकसित करना चाहती है जो ग्राम पंचायत और नगर पालिका स्तर से लेकर राज्य विधानसभा और संसद तक भविष्य के नेता तैयार कर सकें।',
    philosophy_kicker: 'संस्थापक का शासन दर्शन',
    philosophy_title: 'व्यक्ति-निर्भर सरकार से व्यवस्था-संचालित शासन तक',
    philosophy_after: 'अजय व्यक्ति-निर्भर शासन से व्यवस्था-संचालित शासन में परिवर्तन की वकालत करते हैं — समयबद्ध नागरिक सेवाओं, पारदर्शी सार्वजनिक व्यय, कम प्रशासनिक बाधाओं, डिजिटल जवाबदेही, मापने-योग्य सरकारी प्रदर्शन और भ्रष्टाचार के विरुद्ध मज़बूत संस्थागत सुरक्षा-कवच के साथ।',
    mission_kicker: 'एक राष्ट्रीय मिशन',
    mission_title: 'एक राष्ट्र। अनेक भाषाएँ। साझे संवैधानिक सिद्धांत।',
    mission_body: 'एनजीआरपी भारत के सभी क्षेत्रों के लिए है — भारत की भाषाओं, संस्कृतियों और स्थानीय प्राथमिकताओं की विविधता का सम्मान करते हुए, साझे संवैधानिक और शासन के सिद्धांतों को क़ायम रखते हुए।',
    org_philosophy_label: 'संगठनात्मक दर्शन',
    objective_kicker: 'दीर्घकालिक उद्देश्य',
    objective_title: 'व्यक्तियों के ऊपर संविधान। व्यक्तियों से ऊपर संस्थाएँ।',
    signature_label: 'हस्ताक्षर',
    read_more_about: 'एनजीआरपी के बारे में और पढ़ें',
    read_vision: 'संस्थापक दृष्टि पढ़ें',
    read_pan_india: 'अखिल भारतीय आंदोलन पढ़ें',
    read_constitution: 'संविधान पढ़ें',
  },
  mr: {
    nav: 'संस्थापक',
    kicker: 'संस्थापक',
    hero_role: 'संस्थापक — नॅशनल गव्हर्नन्स रिफॉर्म पार्टी',
    credentials_label: 'पात्रता',
    tag_civil_eng: 'सिव्हिल इंजिनिअर',
    tag_entrepreneur: 'उद्योजक',
    tag_infra: 'पायाभूत सुविधा व नवीकरणीय ऊर्जा व्यावसायिक',
    about_kicker: 'संस्थापकांबद्दल',
    about_title: 'भाषणबाजीऐवजी सुधारणा निवडणारा एक नागरिक',
    conviction_label: 'मुख्य विश्वास',
    why_kicker: 'एनजीआरपीची स्थापना का',
    why_title: 'सार्वजनिक नेतृत्वासाठी नवीन पाइपलाइन',
    pipeline_label: 'नेतृत्व पाइपलाइन',
    who_label: 'एनजीआरपी कोणासाठी आहे',
    who_body: 'तरुण. UPSC / MPSC आणि इतर नागरी सेवा उमेदवार. अभियंते, डॉक्टर, वकील, शिक्षक, शेतकरी, उद्योजक, व्यावसायिक, सामाजिक कार्यकर्ते आणि अनुभवी तळागाळातील नेते.',
    independence_label: 'संस्थापकांपासून स्वतंत्रता',
    independence_body: 'एनजीआरपी संस्थापकांवर अवलंबून राहणे हे उद्दिष्ट नाही. त्याऐवजी, एनजीआरपी अशा पारदर्शक अंतर्गत संस्था विकसित करू इच्छिते ज्या ग्रामपंचायत आणि नगरपालिका पातळीपासून राज्य विधिमंडळ आणि संसदेपर्यंत भविष्यातील नेते घडवू शकतील.',
    philosophy_kicker: 'संस्थापकांचे शासन तत्त्वज्ञान',
    philosophy_title: 'व्यक्ती-अवलंबी सरकारकडून व्यवस्था-चालित शासनाकडे',
    philosophy_after: 'अजय व्यक्ती-अवलंबी शासनाकडून व्यवस्था-चालित शासनाकडे संक्रमणाचे समर्थन करतात — कालबद्ध नागरिक सेवा, पारदर्शक सार्वजनिक खर्च, कमी प्रशासकीय अडथळे, डिजिटल जबाबदारी, मोजण्यायोग्य सरकारी कामगिरी आणि भ्रष्टाचाराविरुद्ध मजबूत संस्थात्मक सुरक्षा यांच्यासह.',
    mission_kicker: 'राष्ट्रीय मिशन',
    mission_title: 'एक राष्ट्र. अनेक भाषा. सामायिक संवैधानिक तत्त्वे.',
    mission_body: 'एनजीआरपी भारताच्या सर्व प्रदेशांसाठी आहे — भारताच्या भाषा, संस्कृती आणि स्थानिक प्राधान्यांच्या विविधतेचा आदर करून, सामायिक संवैधानिक व शासन तत्त्वे कायम राखत.',
    org_philosophy_label: 'संघटनात्मक तत्त्वज्ञान',
    objective_kicker: 'दीर्घकालीन उद्दिष्ट',
    objective_title: 'व्यक्तींपेक्षा संविधान. व्यक्तींपेक्षा संस्था.',
    signature_label: 'स्वाक्षरी',
    read_more_about: 'एनजीआरपीबद्दल अधिक वाचा',
    read_vision: 'संस्थापक दृष्टी वाचा',
    read_pan_india: 'अखिल भारतीय चळवळ वाचा',
    read_constitution: 'संविधान वाचा',
  },
};

// ---------------------------------------------------------------------------
// Long-form English content (authoritative)
// ---------------------------------------------------------------------------
export const FOUNDER_CONTENT = {
  name: 'Ajay Pachpute',
  initials: 'AP',
  role: 'Founder — National Governance Reform Party (NGRP)',
  short_line: 'Civil Engineer · Entrepreneur · Infrastructure & Renewable Energy Professional',

  // About paragraphs (rendered in order)
  about: [
    'Ajay Pachpute is the Founder of the National Governance Reform Party (NGRP), envisioned as a pan-India political platform focused on institutional reform, transparent governance, accountability, merit-based leadership and citizen-centric public administration.',
    'A civil engineer, entrepreneur and infrastructure professional, Ajay’s experience spans government contracting, infrastructure development and renewable-energy projects. His professional work has given him direct exposure to the interaction between citizens, businesses, contractors and government systems — including administrative procedures, project implementation, public expenditure and delays in decision-making.',
    'These experiences shaped a central conviction:',
  ],

  conviction_quote: 'India does not merely need changes in political leadership; it needs continuous reform of the systems through which government serves its citizens.',

  // Why NGRP was founded
  why_lede: 'Ajay’s vision for NGRP is to create an institutional alternative in Indian politics where leadership is developed through a clear, merit-based pipeline:',
  pipeline: ['Knowledge', 'Integrity', 'Public Service', 'Performance', 'Public Trust', 'Leadership'],

  // Governance philosophy quote
  philosophy_quote: '“For 140 crore Indians with rising aspirations, government should become simpler, faster, transparent and accountable. Citizens should not have to protest, use influence or repeatedly approach offices to receive legitimate public services. Governance must have a permanent mechanism for continuous reform, measurement and rectification.”',

  // Organisational philosophy chips
  org_philosophy: [
    'National Vision',
    'State-Level Solutions',
    'Local Leadership',
    'Citizen Participation',
  ],

  // Long-term objective (rendered as a card)
  long_term_objective: 'The founder’s long-term objective is to help build a political institution in which the Constitution is above personalities, institutions are stronger than individuals, public service comes before political position, and measurable performance earns public trust.',

  // Signature block chips
  values_line: 'Integrity  •  Accountability  •  Prosperity  •  Service',
  slogan: 'GOOD GOVERNANCE.  STRONG INDIA.  BRIGHTER FUTURE.',
};
